// extracted by mini-css-extract-plugin
module.exports = {"category":"enllac_category__m4mWo","boto":"enllac_boto__RQ8oi"};